<template>
  <div class="flex min-h-screen flex-col bg-blue-lighter">
    <Header hideLogo class="hidden lg:flex" />
    <main class="flex grow flex-col pb-20">
      <slot></slot>
    </main>
    <NavBarMobile />
  </div>
</template>
